export const DEBT_PAGE_TITLE = "Công nợ";

export const FORM_IDS = {
  CREATE_RECEIPT: "create-debt-receipt-form",
  REVIEW_RECEIPT: "review-debt-receipt-form",
};
